import * as actions from '../actions/applicationsAndPolicies';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';
import flattenConcurrently from 'xstream/extra/flattenConcurrently';
import flattenSequentially from 'xstream/extra/flattenSequentially';
import {getArrayQueryParameterMachineName, getLawsysArrayQueryParameter, getSolicitorUsersArrayQueryParameter, isSolicitorUser} from "../helpers/functions";
import sampleCombine from 'xstream/extra/sampleCombine';

export function getLastUpdatePolicy(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_LAST_UPDATE_POLICY_FORM )
		.map(action => ({
			url: BASE_URL + `api/Applications/Updates/` + action.payload + '/last',
			category: 'getLastUpdatePolicy',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getLastUpdatePolicy')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetRequestLastUpdatePolicyForm(JSON.parse(response.text)))

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveFailedResponseGetLastUpdatePolicy(sources) {
    let httpResponse$ = sources.HTTP
        .select('getLastUpdatePolicy')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !== 200)
        .map(response => actions.failedToReceiveLastUpdatePolicyForm(response));

    return {
        ACTION: httpResponse$
    };
}

export function getAllApplications(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_ALL_APPLICATIONS)
		.map(action => ({
			url: BASE_URL + 'api/Applications/Forms?limit=' + action.payload.limit +
				'&offset=' + action.payload.offset +
				'&shallow=' + action.payload.shallow +
				(getArrayQueryParameterMachineName('statuses', action.payload.selectedStatuses) ?
					`&${getArrayQueryParameterMachineName('statuses', action.payload.selectedStatuses)}` : '') +
				(action.payload.search !== null ? '&search=' + action.payload.search : '') +
				(getArrayQueryParameterMachineName('caseTypes', action.payload.selectedCaseTypes) ?
					`&${getArrayQueryParameterMachineName('caseTypes', action.payload.selectedCaseTypes)}` : '') +
					(getArrayQueryParameterMachineName('subCaseTypes', action.payload.selectedSubCaseTypes) ?
					`&${getArrayQueryParameterMachineName('subCaseTypes', action.payload.selectedSubCaseTypes)}` : '') +
				(getLawsysArrayQueryParameter(action.payload.selectedLawsys) ?
					`&${getLawsysArrayQueryParameter(action.payload.selectedLawsys)}` : '') +
				(getSolicitorUsersArrayQueryParameter(action.payload.selectedSolicitorUsers) ?
					`&${getSolicitorUsersArrayQueryParameter(action.payload.selectedSolicitorUsers)}` : ''),
			category: 'getAllApplications',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getAllApplications')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetAllApplications(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badGetApplications(sources) {
	let httpResponse$ = sources.HTTP
		.select('getAllApplications')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadResponseGetAllApplications(response));

	return {
		ACTION: httpResponse$
	};
}


export function getAllApplicationsSuggestions(sources) {
	//below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
	const request$ = sources.ACTION
		.filter(action => action.type === ActionTypes.REQUEST_GET_ALL_APPLICATIONS_SUGGESTIONS )
		.map(action => ({
            url: BASE_URL + 'api/Applications/Forms?limit=' + action.payload.limit +
                '&offset=' + action.payload.offset +
                '&shallow=' + action.payload.shallow +
                '&draft=' +  action.payload.draft +
				'&wonPart36=' +  action.payload.wonPart36 +
				'&live=' +  action.payload.live +
                '&referred=' +  action.payload.referred +
                '&rejected=' +  action.payload.rejected +
                '&closed=' +  action.payload.closed + (action.payload.search !==null? '&search=' + action.payload.search:'') +
                '&won=' +  action.payload.won  +
                '&abandoned=' +  action.payload.abandoned +
                '&clinical=' +  action.payload.clinical +
                '&commercial=' +  action.payload.commercial +
                '&personal=' +  action.payload.personal +
                '&mesothelioma=' +  action.payload.mesothelioma +
                '&nihl=' +  action.payload.nihl +
                '&industrialOther=' +  action.payload.industrialOther +
                '&insolvency=' +  action.payload.insolvency +
                '&el=' +  action.payload.el +
                '&pl=' +  action.payload.pl +
                '&ol=' +  action.payload.ol +
                '&motor=' +  action.payload.motor +
                '&lawsysId=' +  action.payload.lawsysId +
                '&other=' +  action.payload.other +
                (getLawsysArrayQueryParameter(action.payload.selectedLawsys)?
                    `&${getLawsysArrayQueryParameter(action.payload.selectedLawsys)}`:'') +
                (getSolicitorUsersArrayQueryParameter(action.payload.selectedSolicitorUsers)?
                    `&${getSolicitorUsersArrayQueryParameter(action.payload.selectedSolicitorUsers)}`:''),
			category: 'getAllApplicationsSuggestions',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getAllApplicationsSuggestions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
        .compose(flattenSequentially)
		.filter(response => response.status === 200)
		.map(response => actions.receiveGetAllApplicationsSuggestions(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function badGetApplicationsSuggestions(sources) {
	let httpResponse$ = sources.HTTP
		.select('getAllApplicationsSuggestions')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => actions.receiveBadResponseGetAllApplicationsSuggestions(response));

	return {
		ACTION: httpResponse$
	};
}

export function updateSubCaseFilter(sources) {
	const state$ = sources.STATE;
	const allSubCaseTypes$ = state$.map(state => state.caseTypes.subCases);
	const selectedSubCaseTypes$ = state$.map(state => state.applicationsAndPolicies.selectedSubCaseTypes);
	const userRole$ = state$.map(state => state.user.loggedInUser.roles);
	const subCaseTypesSolicitor$ = state$.map(state => state.newApplication.subCaseTypes);

	let action$ = sources.ACTION
		.filter(action => action.type === ActionTypes.CHANGE_APPLICATION_AND_POLICIES_FIELD &&
			action.payload.key === 'selectedCaseTypes')//Action payload is the selected case types
		.compose(sampleCombine(allSubCaseTypes$, selectedSubCaseTypes$, userRole$, subCaseTypesSolicitor$))
		.map(([action, allSubCaseTypes, selectedSubCaseTypes, userRole, subCaseTypesSolicitor]) => {
			var newSelectedSubCases = selectedSubCaseTypes
			var subCaseTypesToFilter = allSubCaseTypes;
			if (isSolicitorUser(userRole)) {
				subCaseTypesToFilter = subCaseTypesSolicitor;
			}
			if (action.payload.value.length > 0) {//filter sub case types options for selected case types
				const caseTypesIds = action.payload.value.map(c => c.value);
				subCaseTypesToFilter = subCaseTypesToFilter.filter(c => caseTypesIds.includes(c.caseTypeId));
				if (selectedSubCaseTypes.length > 0) {//remove no applicable sub case types
					const validSubCasesIds = subCaseTypesToFilter.map(c => c.id);
					const onlyValidSubCaseTypes = selectedSubCaseTypes.filter(c => validSubCasesIds.includes(c.value));
					newSelectedSubCases = onlyValidSubCaseTypes;
				}
			}
			return actions.changeApplicationsAndPoliciesField('selectedSubCaseTypes', newSelectedSubCases)
		})
	return {
		ACTION: action$,
	};
}